import React from 'react'
import PropTypes from 'prop-types'
import { includes } from 'lodash-es'
import { CSSTransitionGroup } from 'react-transition-group'
import { DelayComponent } from '..'

import './AnimateComponent.scss'

const AnimateComponent = (props) => {
  const {
    children = null,
    leaveDuration,
    duration,
    transitionName,
    transitionOn,
    delay,
    className = '',
  } = props

  const appear = includes(transitionOn, 'appear') && {
    transitionAppear: true,
    transitionAppearTimeout: duration,
  }

  const enter = includes(transitionOn, 'enter')
    ? { transitionEnter: true, transitionEnterTimeout: duration }
    : { transitionEnter: false }

  const leave = includes(transitionOn, 'leave')
    ? {
        transitionLeave: true,
        transitionLeaveTimeout: leaveDuration || duration,
      }
    : { transitionLeave: false }

  // don't add wrapper div because most of the time
  // the children are flexbox children
  return (
    <DelayComponent delay={delay}>
      <CSSTransitionGroup
        component="div"
        transitionName={transitionName}
        className={className}
        {...enter}
        {...leave}
        {...appear}
      >
        {children}
      </CSSTransitionGroup>
    </DelayComponent>
  )
}

AnimateComponent.propTypes = {
  children: PropTypes.node,
  duration: PropTypes.number,
  leaveDuration: PropTypes.number,
  delay: PropTypes.number,
  transitionName: PropTypes.oneOfType([
    PropTypes.string, // custom transition
    PropTypes.oneOf(['animation-zoom', 'animation-fade']), // predefined transitions
    PropTypes.shape({
      appear: 'animation-fade-appear',
      enter: 'animation-height-enter',
      leave: 'animation-height-leave',
    }),
  ]),
  transitionOn: PropTypes.arrayOf(
    PropTypes.oneOf(['appear', 'enter', 'leave'])
  ),
  className: PropTypes.string,
}

AnimateComponent.defaultProps = {
  transitionName: 'animation-zoom',
  duration: 500,
  delay: 0,
  transitionOn: ['appear', 'enter', 'leave'],
}

export default AnimateComponent
